import { BrandInfoBase } from "@backend/graph/brand_info/brand-info-base";
import { PracticeEntry } from "./practice";

export class CommonEntry {
  public practice: PracticeEntry;
  /** @ignore This property should only be used by the brand service. If you want to access any brand details use the brand getter inside brand.service.ts */
  public brand_info: BrandInfoBase;
}
